import React, { useEffect, useState,useRef } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import EmailEditor from 'react-email-editor';

import campaignService from '../../services/campaign.service'
function TemplateEmail() {
  const { templateId } = useParams();
  const [template, setTemplate] = useState(null);
  const emailEditorRef = useRef(null);
  const [jsonString,setJsonString] = useState(null);
  const {register,handleSubmit,reset,formState:{errors},} = useForm()
  const navigate = useNavigate()

  useEffect(() => {
   // console.log("template load")
    getTemplate();
  }, [templateId]);

  const getTemplate = () => {
    if (templateId === "new") {
      //It is new template
      const newData = {
        id:null,
        type:"EMAIL",
        name:null,
        preview:null,
        content:null,
        jsonContent:null,
        isActive:0
      }
      setTemplate(newData)
      reset(newData)
    } else {
      //It is existing template
      campaignService.getTemplateById(templateId)
      .then(res=>{
          console.log(res)
          const jo = JSON.parse(res.data.jsonContent)
          emailEditorRef.current.editor.loadDesign(jo);
          setTemplate(res.data)
          reset(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }
  };
  const onReady = () => {
    // editor is ready
   // console.log('onReady');
  };
  const onLoad = () => {
    // editor instance is created
    // you can load your template here;
    // const templateJson = {};
    //  emailEditorRef.current.editor.addEventListener(
    //   'design:loaded',
    //   onDesignLoad
    // );
   getTemplate()
  
  };

  const onSubmit = (submitData) =>{
    //console.log(data)
    emailEditorRef.current.editor.exportHtml((data) => {
        const { design, html } = data;
        const jsonString = JSON.stringify(design)

        const newData = {
            id:submitData.id,
            type:"EMAIL",
            name:submitData.name,
            preview:submitData.preview,
            content:html,
            jsonContent:jsonString,
            isActive:submitData.isActive
        }
        //console.log(newData)
        campaignService.addUpdateTemplate(newData)
        .then(res=>{
            toast.success("Template Updated...",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            reset(res.data)
            setTemplate(res.data)
            navigate('/campaign/template/'+res.data.id)
            

        })
        .catch(err=>{
            toast.error("Error Updating ",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })

    })
  }
  return (
    <>
      <div className="container container-xxl">
        <div className="pagetitle d-flex justify-content-between">
          <h1>Campaign Template</h1>
        </div>
        <div className="card">
          <div className="card-body">
           {template && <>
            <form className="row pt-4" onSubmit={handleSubmit(onSubmit)}>
                <div className="col-10">
                        <div className="row">
                            <div className="col-2">
                                <strong>Id: </strong>
                                {template?.id}
                            </div>
                            <div className="col-2">
                                <div className="form-group">
                                  
                                    <select className="form-select form-select-sm" {...register('isActive')}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-4">
                               
                                <input type="text" {...register("name")} placeholder="Template Name" className="form-control form-control-sm" />
                            </div>
                            <div className="col-4">
                               
                                <input type="text" {...register("preview")} placeholder="image path" className="form-control form-control-sm" />
                            </div>

                          
                        
                    </div>
                </div>
                <div className="col-2">
                    <div className="d-flex justify-content-end">
                       
                         <button type="submit" className="btn btn-sm btn-success me-2">Save</button>
                         <button className="btn btn-sm btn-secondary">Back</button>
                    </div>
                     
                </div>
            </form>
            </>}
          </div>
        </div>

        {/**
         * Display Email Editor over here
         */}
           <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} style={{height:"80vh"}} />
      </div>
    </>
  );
}

export default TemplateEmail;
